// extracted by mini-css-extract-plugin
module.exports = {"centerPosition":"LoginStyle_centerPosition__2GuQG"};